import { __ } from '../locales';
import { cleanHtml } from './common';

export const mumQuizReducer = (quizData, lessons) => quizData.map(({
  mat_nm: title,
  correct_disposal_option: correctOption,
  options,
  mat_id
}, i) => ({
  id: mat_id,
  oidx: i,
  answered: false,
  image: '',
  question: __('app.where_does_go'),
  wrongAnswerFeedback: cleanHtml(lessons[mat_id].body),
  correctAnswerFeedback: '',
  options: options.map(({
    disposal_nm: label,
    disposal_id
  }) => ({
    label: cleanHtml(label),
    id: disposal_id,
    value: disposal_id,
    selected: false,
    nuetral: true
  })),
  title,
  correctOption,
}));

export const rfQuizReducer = (quizData, lessons) => {
  const quiz = quizData.map(({
    campaign_id,
    campaign_coachable_id,
    correct_answer_feedback: correctAnswerFeedback,
    wrong_answer_feedback: wrongAnswerFeedback,
    image_path: image,
    quiz_correct_answer: correctOption,
    poll_quiz_question: question,
    ...options
  }, i) => ({
    id: campaign_coachable_id,
    activityId: campaign_id,
    correctAnswerFeedback: cleanHtml(correctAnswerFeedback),
    wrongAnswerFeedback: cleanHtml(wrongAnswerFeedback),
    oidx: i,
    answered: false,
    question: cleanHtml(question),
    title: lessons[campaign_id].title,
    options: Object
      .keys(options)
      .filter((opt) => options[opt])
      .map((opt) => ({
        label: cleanHtml(options[opt]),
        id: Number(opt.substr(17)),
        value: Number(opt.substr(17)),
        selected: false,
        nuetral: true
      })),
    image,
    correctOption
  }));
  return quiz;
};

export const lmQuizReducer = (lmData) => {
  const quizzes = lmData.map((item) => {
    const quiz = item.quizzes.map(({
      campaign_id,
      coachable_id,
      image_path: image,
      quiz_correct_answer: correctOption,
      poll_quiz_question: question,
      video_title,
      ...options
    }, i) => ({
      id: coachable_id,
      oidx: i,
      answered: false,
      question: cleanHtml(question),
      title: video_title,
      activityId: coachable_id,
      campaign_id,
      options: Object
        .keys(options)
        .filter((opt) => options[opt])
        .map((opt) => ({
          label: cleanHtml(options[opt]),
          id: Number(opt.substr(17)),
          value: Number(opt.substr(17)),
          selected: false,
          nuetral: true
        })),
      image,
      correctOption
    }));
    return quiz;
  });
  return quizzes;
};
